import { SxProps, Theme } from '@mui/material/styles';

export const rowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const cardSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  backgroundColor: '#1E1F25',
  p: 2,
};

export const infoRowSx: SxProps<Theme> = {
  ...rowSx,
  justifyContent: 'space-between',
};

export const labelSx: SxProps<Theme> = {
  fontSize: 16,
  color: '#CCD4FF',
};

export const valueSx: SxProps<Theme> = {
  fontSize: 16,
};

export const totalLabelSx: SxProps<Theme> = {
  fontSize: 16,
  color: '#CCD4FF',
};

export const totalValueSx: SxProps<Theme> = {
  fontSize: 18,
  fontWeight: 'bold',
  color: '#4F66FF',
};

export const dividerSx: SxProps<Theme> = {
  backgroundColor: '#FFFFFF1A',
  height: 2,
};
